import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AtualizaSenhaComponent } from './auth/atualiza-senha/atualiza-senha.component';
import { AuthLayoutComponent } from './shared/layout/app-layouts/auth-layout.component';
import { MainLayoutComponent } from './shared/layout/app-layouts/main-layout.component';
import { AuthGuard } from './_guards/auth.guard';
import { UserClaimGuard } from './_services/user-claim-guard.service';
import { CustomGuard } from './app.guard';

export const routes: Routes = [
  {
    path: '',
    component: MainLayoutComponent,
    children: [
      {
        path: '', redirectTo: 'home', pathMatch: 'full',
      },
      {
        path: 'home',
        loadChildren: 'app/home/home.module#HomeModule',
        canActivate: [AuthGuard, CustomGuard]
      },
      {
        path: 'usuario',
        loadChildren: 'app/usuario/usuario.module#UsuarioModule',
        data: { pageTitle: 'Usuário' },
        canActivate: [AuthGuard, CustomGuard],
        canActivateChild: [UserClaimGuard],
      },
      {
        path: 'perfil',
        loadChildren: 'app/perfil/perfil.module#PerfilModule',
        data: { pageTitle: 'Perfil' },
        canActivate: [AuthGuard, CustomGuard],
        canActivateChild: [UserClaimGuard]
      },
      {
        path: 'modulo',
        loadChildren: 'app/gestaomodulos/gestaomodulos.module#GestaoModuloModule',
        data: { pageTitle: 'Módulos' },
        canActivate: [AuthGuard, CustomGuard],
        canActivateChild: [UserClaimGuard]
      },
      {
        path: 'alterarSenha',
        loadChildren: 'app/alterarsenha/alterarsenha.module#AlteraSenhaModule',
        data: { pageTitle: 'Alterar Senha' },
        canActivate: [AuthGuard, CustomGuard],
        canActivateChild: [UserClaimGuard]
      }
    ]
  },
  {
    path: 'atualiza-senha/:userId/:code',
    component: AtualizaSenhaComponent,
    loadChildren: 'app/auth/auth.module#AuthModule'
  },
  {
    path: 'login',
    component: AuthLayoutComponent,
    loadChildren: 'app/auth/auth.module#AuthModule'
  },
  { path: '**', redirectTo: 'login' }

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: true });



// WEBPACK FOOTER //
// ./src/app/app.routing.ts